export type ContentBadgeModeType = 'primary' | 'secondary' | 'outline';

export type ContentBadgeSizeType = 's' | 'm' | 'l';
